const activate_loader = (DOM) => {
  try {
    DOM.querySelector(".loader-button__text").style.display = "none";
    DOM.querySelector(".loader-button__loader").removeAttribute("hidden");
    DOM.querySelector(".loader-button__loader").style.opacity = "1";
    DOM.querySelector(".loader-button__loader").style.color = "#000000";
  } catch (error) {
    console.log(error);
  }
};

const removeDiscountCodeFromCart = () => {
  try {
    addDiscountCodeToCart(null);
  } catch (error) {
    console.log(error);
  }
};

const displayFreeShippingBanner = (totalCartCost) => {
  try {
    const minimum_order_price = 100;

    // if (totalCartCost == 0.0) return false;
    // const bannerElement = document.getElementById("cart_banner");
    // bannerElement.style.display = "block";
    const remainAmountForFreeShipping = minimum_order_price - totalCartCost;
    console.log(minimum_order_price, totalCartCost, remainAmountForFreeShipping)
    if (remainAmountForFreeShipping > 0) {
      bannerElement.style.display = "none";

      // bannerElement.innerText = `ADD $${remainAmountForFreeShipping.toFixed(
      //   2
      // )} TO YOUR CART FOR FREE SHIPPING`;
      // if (cartItems?.cart?.discountCodes.length > 0) {
      //   // addDiscountCodeToCart(null)
      // }
      // bannerElement.style.backgroundColor = "black";
    } 
    else {
      // if(cartItems?.cart?.discountCodes.length === 0){
      //   addDiscountCodeToCart(discountCode)
      // }
      // addDiscountCodeToCart(discountCode)
      const bannerElement = document.getElementById("cart_banner");
      bannerElement.style.display = "block";
      bannerElement.style.backgroundColor = "green";
      bannerElement.innerText = `YOU GET FREE SHIPPING!`;
    }
  } catch (error) {
    console.log(error);
  }
};

const display_mini_cart_items = async () => {
  console.log("display_mini_cart_items .....");
  console.log("cartItems ====>", cartItems)
  let checkoutURL;
  let totalCartCost;
  let CartCurrencyCode;

  setTotalYMQCustomProductPriceTo_0();

  const updateCheckoutPriceAndCartIconCount = async () => {
    try {
      checkoutURL = cartItems?.cart?.checkoutUrl || "/";
      totalCartCost = parseFloat(
        cartItems?.cart?.estimatedCost?.subtotalAmount?.amount
      ).toFixed(2);
      CartCurrencyCode =
        cartItems?.cart?.estimatedCost?.subtotalAmount?.currencyCode;

      updateCheckoutButtonMinicart(`${totalCartCost} ${CartCurrencyCode}`);
      calculatCartItems(cartItems);
    } catch (error) {
      console.log(error);
    }
  };
  updateCheckoutPriceAndCartIconCount();
  removeDiscountCodeFromCart();
  displayFreeShippingBanner(totalCartCost);
  
  let globalCartsItems = cartItems?.cart?.lines?.edges;
  console.log("globalCartsItems ===> ", globalCartsItems);
  // redirect user to certor checkout page
  const checkout_button = document.querySelectorAll(".checkout-button");
  if (checkout_button[0]) {
    checkout_button[0].addEventListener(
      "click",
      (e) => {
        try {

          if(parseInt(totalCartCost) === 0 ||  !totalCartCost){
            trigger_cutomeEvent.CartNotification_error("Shopping Cart Is Empty")
            return false
          }
          
          // console.log(e.target)
          activate_loader(e.target);

          e.preventDefault();
          e.stopPropagation();
          window.location = checkoutURL;
        } catch (error) {
          console.log(error);
        }
      },
      true
    );
  }

  const lineItemDomElement = async (item, index) => {
    try {
      console.log("item cart", item)
      if (item.node.quantity === 0) return 
      const item_subtotalAmount = item.node.estimatedCost.subtotalAmount.amount;
      const itsBundleProduct = item_subtotalAmount === "0.0";

      const CartIcon = document.getElementsByTagName("cart-count");
      CartIcon[0].innerText = CartIcon_quantity;
      const lineItem = document
        .getElementById("line-item_example")
        .cloneNode(true);
      lineItem.style.display = "flow-root";
      lineItem.querySelector(".line-item__image").src =
        item.node.merchandise?.image?.url ||
        "https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_92x.gif";
      lineItem.querySelector(".product-item-meta__title").innerText =
        item.node.merchandise.product.title;

      if (item.node.merchandise.product.title.includes("CUSTOM")) {
        lineItem.classList.add("custom-prod");
      }

      lineItem.id = `CartItem-${item.node.id}`;

      // if this item is custom product
      if (item.node.attributes.length > 1) {
        const attributes_and_options = item.node.attributes.concat(
          item.node.merchandise.selectedOptions
        );
        createListPropertiesDomElement(attributes_and_options, lineItem);
      } else {
        if (lineItem.querySelector("#product_vendor_name")) {
          lineItem.querySelector("#product_vendor_name").innerText =
            item.node.merchandise.product.vendor;
        }

        const giftProductID = item.node.merchandise.product.giftProductID
        let freeGiftLine = "";
        if(item.node.merchandise.product.giftProductID) {
          const variantData = await getVariantData(giftProductID.value)
          console.log("variantData", variantData)
          freeGiftLine = document.createElement("P");
          freeGiftLine.innerText = `1 X ${variantData.product.title}`
        }
        // lineItem.querySelector("#line_item_properties").innerText =
        let productOtionsDomElement = document.createElement("P");
        const productOtions = item.node.merchandise.selectedOptions
          .map((option) => {
            return option.value;
          })
          .join(" / ");

        productOtionsDomElement.innerText = productOtions;

        let preOrder = "";
        if(item.node.sellingPlanAllocation) {
          if(item.node.sellingPlanAllocation.sellingPlan.name.includes("🟣")) {
            preOrder = document.createElement("P");
            preOrder.textContent = `Pre-Order: ${item.node.sellingPlanAllocation.sellingPlan.name}`
          }
        }
        
        lineItem
          .querySelector("#line_item_properties")
          .append(productOtionsDomElement, freeGiftLine, preOrder);
        createListPropertiesDomElement(item.node.attributes, lineItem);
      }
      const priceLable = lineItem.querySelectorAll(".price");
      priceLable[0].innerHTML = itsBundleProduct
        ? `<p style="color:green">Free</p>`
        : "$" + parseFloat(item_subtotalAmount).toFixed(2);
      priceLable[1].innerHTML = itsBundleProduct
        ? `<p style="color:green">Free</p>`
        : "$" + parseFloat(item_subtotalAmount).toFixed(2);

      const quantity_selector__input = lineItem.querySelector(
        ".quantity-selector__input"
      );
      quantity_selector__input.value = item.node.quantity;

      if (document.getElementById("drawer__content-footer_example")) {
        document.getElementById(
          "drawer__content-footer_example"
        ).style.display = "block";
      }

      if (item.node.attributes.length <= 1 && !itsBundleProduct) {
        // minus

        quantity_selector__input.previousElementSibling.addEventListener(
          "click",
          async () => {
            document.documentElement.dispatchEvent(
              new CustomEvent("variant:updated", {
                bubbles: true,
                detail: {
                  lineItem: lineItem,
                  id: item?.node?.id,
                  quantity: item?.node?.quantity - 1,
                  quantityToUpdate: -1,
                  handle: item?.node?.merchandise?.product?.handle,
                  attributes: item?.node?.attributes,
                },
              })
            );
          }
        );

        //plus
        quantity_selector__input?.nextElementSibling.addEventListener(
          "click",
          async () => {
            document.documentElement.dispatchEvent(
              new CustomEvent("variant:updated", {
                bubbles: true,
                detail: {
                  lineItem: lineItem,
                  id: item.node.id,
                  quantity: item.node.quantity + 1,
                  quantityToUpdate: 1,
                  handle: item?.node?.merchandise?.product?.handle,
                  attributes: item.node.attributes,
                },
              })
            );
          }
        );
      } else if (item.node.attributes.length > 1) {
        quantity_selector__input.parentElement.style.display = "none";
      }

      // remove item
      lineItem
        .querySelector(".line-item__remove-button")
        .addEventListener("click", async () => {
          document.documentElement.dispatchEvent(
            new CustomEvent("variant:updated", {
              bubbles: true,
              detail: {
                lineItem: lineItem,
                id: item.node.id,
                quantity: 0,
                quantityToUpdate: -item.node.quantity,
                handle: item?.node?.merchandise?.product?.handle,
                attributes: item.node.attributes,
              },
            })
          );
        });

      itsBundleProduct &&
        (lineItem.querySelector(".line-item__remove-button").style.display =
          "none");

      const mini_cart_form = document.getElementById("mini-cart-form");
      mini_cart_form.appendChild(lineItem);
    } catch (error) {
      console.log(error);
    }
  };

  //giftProduct_functions.giftProduct_validationCheck(globalCartsItems);
  console.log("globalCartsItems2", globalCartsItems)
  // find gift product on cart
  globalCartsItems.map(async (item, index) => {
    try {
      if (!document.getElementById("drawer__content")) {
        document.getElementById("emptyCart_drawer").style.display = "none";
        const drawer__content_DomElement = document.getElementById(
          "drawer__content-example"
        );
        drawer__content_DomElement.style.display = "block";
      }

      if (document.getElementById(`CartItem-${item.node.id}`)) {
        document.getElementById(`CartItem-${item.node.id}`).remove();
      }
       if(item.node.merchandise.product.cartDisable || item.node.id === "gid://shopify/ProductVariant/45688076533986") {
        await updateProductToCart_Request(
              item.node.id,
              0,
              globalCartID_Cookies
            );
        trigger_cutomeEvent.globalVariant_add();
      } else {
         lineItemDomElement(item, index);
      }
    } catch (error) {
      console.log(error);
    }
  });
  try {
    let AddToCart = document.getElementById("AddToCart")
    const newAddToCart = AddToCart.cloneNode(true)
    AddToCart.replaceWith(newAddToCart);
  } catch (error) {
    console.log("error in replacing addToCart DOM by it's copy",error)
  }
};
